var map = {
	"./CaretDown.png": "8938",
	"./Group 212.png": "0e20",
	"./bi-marketplace-1.png": "b9f1",
	"./bi-marketplace-2.png": "7008",
	"./dataManagement-1.png": "adda",
	"./dataManagement-2.png": "2c09",
	"./dataManagement-3.png": "b5f9",
	"./dataManagement-4.png": "7592",
	"./image 60.png": "d555",
	"./image 62.png": "7a66",
	"./logos_microsoft-power-bi.png": "c3d3",
	"./newUpload-1.png": "4ff8",
	"./newUpload-2.png": "f7e2",
	"./newUpload-3.png": "86d1",
	"./newUpload-4.png": "1ced",
	"./overview.png": "4973",
	"./roles-management.png": "9acb",
	"./star-full.png": "d389",
	"./users-1.png": "53bc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";